import { useEffect, useMemo, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import debounce from 'lodash/debounce';

import { SearchIcon } from '@svgs';

import { SearchProjects } from './SearchProjects/SearchProjects.jsx';
import { SearchSites } from './SearchSites/SearchSites.jsx';
import { SearchUsers } from './SearchUsers/SearchUsers.jsx';

import { Loader } from '@components';

import './SidebarSearch.scss';

export const SidebarSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // https://medium.com/nerd-for-tech/debounce-your-search-react-input-optimization-fd270a8042b
  const debouncedResults = useMemo(() => {
    return debounce(handleChange, 300);
  }, []);
  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  const onSubmit = (e) => {
    e.preventDefault();
    const searchVal = e.target.getElementsByTagName('input')[0].value;
    navigate(`/dashboard/search?q=${searchVal}`);
  };

  return (
    <div className="sb-sidebar-header">
      <div className="sb-sidebar-search">
        <form onSubmit={onSubmit}>
          <input
            type="search"
            placeholder="Search anything"
            autoComplete="off"
            defaultValue={searchTerm}
            onChange={debouncedResults}
          />
          <SearchIcon />
        </form>
        {searchTerm && searchTerm.length >= 3 && (
          <div className="sb-sidebar-search-results">
            <SearchSites searchTerm={searchTerm} />
            <SearchProjects searchTerm={searchTerm} />
            <SearchUsers searchTerm={searchTerm} />
            <p className="sb-search-note">
              Hit return/enter to{' '}
              <Link to={`/dashboard/search?q=${searchTerm}`}>
                view all results
              </Link>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
